// Injeta GA4/GTM/Meta/Google Ads/TikTok conforme IDs configurados no Admin.
// Pixels de marketing só carregam após consentimento (LGPD). GA/GTM carregam sempre (medição).
let loaded = false;

function addScript(src, attrs = {}) {
  if (document.querySelector(`script[data-mc="${attrs["data-mc"]}"]`)) return;
  const s = document.createElement("script");
  s.async = true; s.src = src;
  Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
  document.head.appendChild(s);
}

export function initAnalytics(a, consent) {
  if (!a || loaded) return;
  window.dataLayer = window.dataLayer || [];
  if (a.gtm) {
    addScript(`https://www.googletagmanager.com/gtm.js?id=${a.gtm}`, { "data-mc": "gtm" });
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  }
  if (a.ga4) {
    addScript(`https://www.googletagmanager.com/gtag/js?id=${a.ga4}`, { "data-mc": "ga4" });
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", a.ga4);
    if (a.google_ads) window.gtag("config", a.google_ads);
  }
  loaded = true;
  if (consent) loadMarketing(a);
}

let mkLoaded = false;
export function loadMarketing(a) {
  if (!a || mkLoaded) return;
  mkLoaded = true;
  if (a.meta_pixel) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", a.meta_pixel); window.fbq("track", "PageView");
    /* eslint-enable */
  }
  if (a.tiktok_pixel) {
    /* eslint-disable */
    !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.load=function(e){var n="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=n;var o=d.createElement("script");o.type="text/javascript";o.async=!0;o.src=n+"?sdkid="+e;var a=d.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};ttq.load(a.tiktok_pixel);ttq.page()}(window,document,"ttq");
    /* eslint-enable */
  }
}

export function track(event, data) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...(data || {}) });
    if (window.fbq) window.fbq("trackCustom", event, data || {});
    if (window.ttq) window.ttq.track(event, data || {});
  } catch (e) { /* noop */ }
}

export function captureUTM() {
  try {
    const p = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
    const utm = {};
    keys.forEach((k) => { const v = p.get(k); if (v) utm[k] = v; });
    if (p.get("ref")) utm.ref = p.get("ref");
    if (document.referrer) utm.referrer = document.referrer;
    if (Object.keys(utm).length) localStorage.setItem("mc_utm", JSON.stringify(utm));
  } catch (e) { /* noop */ }
}
export function getUTM() {
  try { return JSON.parse(localStorage.getItem("mc_utm") || "null"); } catch (e) { return null; }
}
